import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { animate, style, transition, trigger } from '@angular/animations';
import { PortalETicketNode } from '@app/services/api/api.types';
import { TravelerInfoBlocks } from '@app/components/traveler-info/traveler-info.enum';

@Component({
  selector: 'traveler-info',
  templateUrl: './traveler-info.component.html',
  styleUrls: ['./traveler-info.component.scss'],
  animations: [
    trigger('toggle', [
      transition(':enter', [
        style({ height: 0 }),
        animate('0.15s ease-in', style({ height: '*' })),
      ]),
      transition(':leave', [
        style({ height: '*' }),
        animate('0.15s ease-in', style({ height: 0 })),
      ]),
    ]),
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TravelerInfoComponent {
  @Input() data: PortalETicketNode;
  @Input() fields: TravelerInfoBlocks[];
  @Input() additionalFields: TravelerInfoBlocks[];

  protected isCollapsed = true;
  protected travelerInfoBlocks = TravelerInfoBlocks;
}
